import { mapGetters } from "vuex";

/**
 * Permite combinar varios mapGetters con diferentes namespaces
 * en una sola llamada.
 *
 * Ejemplo:
 * mapMultiGetters([
 *   ["namespace1", ["getter1", "getter2"]],
 *   ["namespace2", { aliasGetter: "realGetter" }]
 * ])
 */
export function mapMultiGetters(configs) {
    return configs.reduce((acc, [namespace, getters]) => {
        return Object.assign(acc, mapGetters(namespace, getters));
    }, {});
}
